import React from "react";
import classNames from 'classnames';
import get from "lodash/get";
import TimeAgo from 'react-timeago';
import format from "date-fns/format";
import { Link, ResponsiveHeroImage, ReviewRating } from "@quintype/components";

import { Author } from "./author.js";
import { ImageFallback } from "./image-fallback.js";
import { SectionName } from "./section-name.js";
import { truncate } from "../../../utils/truncate-string";
import { altTagOfHeroImages} from "../../utils";

function formatter(value, unit, suffix, date, defaultFormatter) {
  		return format(new Date(date), 'DD MMM, YYYY [at] HH:mm A');
}

export function StoryCard(props) {
  // The `props.story` can be an item from items of a collection or a story itself.
  // assigning it accordinlgy.
  const story = props.story && props.story.type === 'story' && props.story.story ? props.story.story : props.story;
  return !story ? null :
    <Link href={`/${story.slug}`} className="story-card-link">
      {
        props.type === 'imageBackground' ?
        <StoryCardBgImage story={story} config={props.config} hideSectionName={props.hideSectionName} /> :
        <StoryCardSimple story={story} config={props.config} hideSectionName={props.hideSectionName} showDate={props.showDate}/> 
      }
    </Link>;
}


export function StoryCardBgImage(props) {
  const author = {
    name: get(props.story, ['authors', 0, 'name'], props.story['author-name']),
    id: get(props.story, ['authors' , 0, 'id'] , props.story['author-id'])
  };
  const isReviewStory = props.story["story-template"] === 'review';

  return (
      <div className={`story-card ${props.story['story-template'] === "video" ? 'story-card__image__video' : '' }`}>
        { (props.config && props.config.image) && <ImageRenderComponent {...props} /> }
        <div className="story-card__content story-card__content--over-image">
          { !props.hideSectionName && (props.story.sections && props.story.sections.length !== 0) && <SectionName hideLink={true} inlineStyle={props.sectionInlineStyle} name={props.story.sections[0]['display-name'] || props.story.sections[0]['name']}/>}
          <h2 className="story-card__heading"><bdi dangerouslySetInnerHTML={ {__html: props.story.headline }}></bdi></h2>
          {isReviewStory && <ReviewRating value={get(props.story, ['metadata','review-rating', 'value'], '0')} />}
          {!props.hideAuthor && <Author author={author} />}
        </div>
      </div>
  )
}


export function StoryCardSimple(props) {
  const author = {
    name: get(props.story, ['authors', 0, 'name'], props.story['author-name']),
    id: get(props.story, ['authors' , 0, 'id'] , props.story['author-id'])
  };
  const isReviewStory = props.story["story-template"] === 'review';

   const publishedTime = props.story['last-published-at'] ? props.story['last-published-at'] : props.story['first-published-at']; 

  // We can customize this component by passing down a config
  // We can enable Image, Subheadline and Section name if the config values are true.
  // By default we'll hide all.
  return (
      <div className={classNames('story-card', { 'story-card--transparent': props.config && props.config.transparent })}>
        { props.pickOfTheDay && <p className="pick-of-the-day">{props.titleofTheHighlightedStory ? truncate(props.titleofTheHighlightedStory, 30, false) : ""}</p> }
        { (props.config && props.config.image) && <ImageRenderComponent {...props} /> }
        <div className={classNames('story-card__content', { 'story-card__content--transparent': props.config && props.config.transparent })}>
          {props.config && props.config.image && props.isReviewStory && <ReviewRating value={get(props.story, ['metadata','review-rating', 'value'], '0')} />}
          { !props.hideSectionName && (props.story.sections && props.story.sections.length !== 0) && <SectionName hideLink={true} inlineStyle={props.sectionInlineStyle} name={props.story.sections[0]['display-name'] || props.story.sections[0]['name']}/> }
          <h2 className="story-card__heading"><bdi dangerouslySetInnerHTML={ {__html: props.story.headline}}></bdi></h2>
          {isReviewStory && <ReviewRating value={get(props.story, ['metadata','review-rating', 'value'], '0')} />}
          { props.config && props.config.subheadline && <p className="story-card__description" dangerouslySetInnerHTML={ {__html: props.story.subheadline } } /> }
          { !props.hideAuthor && <Author author={author} /> }
          { props.showDate && <p className="author__published-date"><span className="author__posted-keyword">{ !props.showDateOnly && 'Posted' }</span><TimeAgo date={publishedTime} formatter={formatter}/></p>}
        </div>
      </div>
  )
}

export function ImageRenderComponent({story, config}) {
  const {imageAspectRatio} = config;
  const aspectRatioClass = imageAspectRatio ? `${imageAspectRatio[0]}x${imageAspectRatio[1]}` : "16x9";

  return story["hero-image-s3-key"] ?
    <div className={`story-card__image--${aspectRatioClass}`}>
      <figure className={`story-card__image ${story['story-template'] === "video" ? "story-card__image__video" : ""}`}>
        <ResponsiveHeroImage story={story}
          aspectRatio={imageAspectRatio ? imageAspectRatio : [16, 9]}
          alt={altTagOfHeroImages(story)}
          defaultWidth={480} widths={[250,480,640]} sizes="(max-width: 500px) 98%, (max-width: 768px) 48%, 23%"
          imgParams={{auto:['format', 'compress'], fit:'max'}}/>
      </figure>
    </div> :
    <div className={`story-card__image--${aspectRatioClass}`}>
      <ImageFallback className="story-card__image"/>
    </div>;
}